export const ApprovalType = {
    CREATE: '新增',
    MODIFY: '编辑',
    DELETE: '删除'
}

export const ApprovalStatus = {
    CREATED: '审批中',
    DONE: '审批完成',
    CANCEL: '审批撤销'
}
